// 完整的多语言翻译文件
export const translations = {
    en: {
        // Navigation
        navTitle: "AI Webtoon Maker",
        navSubtitle: "Storytelling First",
        signIn: "Sign In",
        
        // Hero Section
        heroTitle: "🎬 Storytelling First",
        heroSubtitle: "Create Webtoon Videos with Perfect Character Consistency",
        heroDescription: "The only AI tool that combines Story + Character + Multi-language Lip Sync",
        startCreating: "🚀 Start Creating Free",
        watchDemo: "🎭 Watch Demo",
        
        // Features
        feature1Title: "Storytelling First",
        feature1Desc: "Generate complete story arcs with character development and emotional progression. Not just videos, but meaningful narratives.",
        feature2Title: "Character Consistency",
        feature2Desc: "Maintain consistent character appearance across scenes. One character, multiple scenes, perfect consistency every time.",
        feature3Title: "Perfect Lip Sync",
        feature3Desc: "Multi-language lip sync support. English, Chinese, Japanese, Korean, Spanish, French, German - all with perfect mouth animation.",
        
        // FAQ
        faqTitle: "Common Questions",
        faqSubtitle: "Have other questions? Contact us at",
        faq1Q: "What is ToonSync and how does it work?",
        faq1A: "ToonSync is the world's first AI webtoon video maker that prioritizes storytelling. It uses advanced AI models to generate consistent characters, coherent story arcs, and perfect lip-sync animation from your text descriptions.",
        faq2Q: "Is ToonSync really free to use?",
        faq2A: "Yes, ToonSync offers a generous free tier that allows you to create short webtoon videos with no credit card required. We believe in empowering creators to tell their stories without barriers.",
        faq3Q: "How do you maintain character consistency?",
        faq3A: "We use proprietary 'Character Lock' technology. Once you define a character, our system maintains their facial features, clothing, and style across all generated scenes, regardless of camera angle or pose.",
        faq4Q: "What languages are supported for lip sync?",
        faq4A: "We currently support perfect lip synchronization for English, Chinese (Mandarin), Japanese, Korean, Spanish, French, and German, with more languages coming soon.",

        // Comparison
        whyDifferentTitle: "Why We're Different",
        otherToolsTitle: "❌ Other AI Video Tools",
        ourToolTitle: "✅ AI Webtoon Maker",
        runway: "Runway: Great videos, no story coherence",
        civitai: "Civitai: Only static images, no video",
        did: "D-ID: Real humans only, no anime style",
        heyGen: "HeyGen: Business focus, no creativity",
        synthesia: "Synthesia: Templates only, no customization",
        storyCoherence: "Story Coherence: Complete narrative arcs",
        characterConsistency: "Character Consistency: Same character, every scene",
        multiLangLipSync: "Multi-language Lip Sync: 7+ languages supported",
        creatorFocused: "Creator Focused: Built for storytellers",
        animeStyle: "Anime/Manga Style: Perfect for webtoons",
        
        // Language Support
        languageSupportTitle: "🌍 Global Language Support",
        englishLabel: "English",
        englishDesc: "ElevenLabs Premium",
        chineseLabel: "Chinese",
        chineseDesc: "Azure Optimized",
        japaneseLabel: "Japanese",
        japaneseDesc: "Anime Style",
        koreanLabel: "Korean",
        koreanDesc: "K-pop Style",
        spanishLabel: "Spanish",
        spanishDesc: "ElevenLabs",
        frenchLabel: "French",
        frenchDesc: "ElevenLabs",
        germanLabel: "German",
        germanDesc: "ElevenLabs",
        moreLabel: "More",
        moreDesc: "Coming Soon",
        
        // Pricing
        pricingTitle: "💰 Simple Pricing",
        freeTitle: "Free",
        freePrice: "$0",
        freeFeature1: "3 projects",
        freeFeature2: "5-minute videos",
        freeFeature3: "Basic characters",
        freeFeature4: "English TTS",
        freeButton: "Get Started",
        proTitle: "Pro",
        proPrice: "$29",
        proMonth: "/mo",
        proPopular: "POPULAR",
        proFeature1: "Unlimited projects",
        proFeature2: "30-minute videos",
        proFeature3: "Advanced characters",
        proFeature4: "Multi-language TTS",
        proFeature5: "Character consistency AI",
        proButton: "Start Pro Trial",
        enterpriseTitle: "Enterprise",
        enterprisePrice: "$99",
        enterpriseFeature1: "Team collaboration",
        enterpriseFeature2: "API access",
        enterpriseFeature3: "Custom character training",
        enterpriseFeature4: "Priority support",
        enterpriseFeature5: "White-label options",
        enterpriseButton: "Contact Sales",
        
        // CTA
        ctaTitle: "Ready to Create Amazing Webtoon Videos?",
        ctaSubtitle: "Join thousands of creators who are already using AI Webtoon Maker",
        startNow: "🚀 Start Creating Now",
        contactUs: "📧 Contact Us",
        
        // Footer
        footerText: "Made with ❤️ for global creators",
        support: "Support",
        privacy: "Privacy",
        terms: "Terms"
    },
    zh: {
        // Navigation
        navTitle: "AI漫剧制作器",
        navSubtitle: "故事优先",
        signIn: "登录",
        
        // Hero Section
        heroTitle: "🎬 故事优先",
        heroSubtitle: "创建具有完美角色一致性的漫剧视频",
        heroDescription: "唯一结合故事+角色+多语言口型同步的AI工具",
        startCreating: "🚀 免费开始创作",
        watchDemo: "🎭 观看演示",
        
        // Features
        feature1Title: "故事优先",
        feature1Desc: "生成完整的故事弧线，包含角色发展和情感进展。不仅仅是视频，更是有意义的叙事。",
        feature2Title: "角色一致性",
        feature2Desc: "在不同场景中保持角色外观一致。一个角色，多个场景，每次都完美一致。",
        feature3Title: "完美口型同步",
        feature3Desc: "多语言口型同步支持。英文、中文、日文、韩文、西班牙文、法文、德文 - 都有完美的嘴部动画。",
        
        // FAQ
        faqTitle: "常见问题",
        faqSubtitle: "还有其他问题？联系我们：",
        faq1Q: "ToonSync是什么，它是如何工作的？",
        faq1A: "ToonSync是世界上第一个优先考虑叙事的AI漫剧制作器。它使用先进的AI模型，根据您的文字描述生成一致的角色、连贯的故事弧线和完美的口型同步动画。",
        faq2Q: "ToonSync真的免费吗？",
        faq2A: "是的，ToonSync提供慷慨的免费层级，允许您创建短漫剧视频，无需信用卡。我们相信赋能创作者无障碍地讲述他们的故事。",
        faq3Q: "你们如何保持角色一致性？",
        faq3A: "我们使用专有的'角色锁定'技术。一旦您定义了一个角色，我们的系统就会在所有生成的场景中保持他们的面部特征、服装和风格，无论摄像机角度或姿势如何。",
        faq4Q: "口型同步支持哪些语言？",
        faq4A: "我们目前支持英语、中文（普通话）、日语、韩语、西班牙语、法语和德语的完美口型同步，更多语言即将推出。",

        // Comparison
        whyDifferentTitle: "我们的不同之处",
        otherToolsTitle: "❌ 其他AI视频工具",
        ourToolTitle: "✅ AI漫剧制作器",
        runway: "Runway：视频质量好，但无故事连贯性",
        civitai: "Civitai：只有静态图片，无视频",
        did: "D-ID：仅支持真人，无动漫风格",
        heyGen: "HeyGen：商务导向，无创意内容",
        synthesia: "Synthesia：模板化，无个性化",
        storyCoherence: "故事连贯性：完整的叙事弧线",
        characterConsistency: "角色一致性：同一角色，每个场景",
        multiLangLipSync: "多语言口型同步：支持7种以上语言",
        creatorFocused: "创作者导向：为故事创作者打造",
        animeStyle: "动漫/漫画风格：完美适配漫剧",
        
        // Language Support
        languageSupportTitle: "🌍 全球语言支持",
        englishLabel: "英文",
        englishDesc: "ElevenLabs 高级版",
        chineseLabel: "中文",
        chineseDesc: "Azure 优化",
        japaneseLabel: "日文",
        japaneseDesc: "动漫风格",
        koreanLabel: "韩文",
        koreanDesc: "K-pop 风格",
        spanishLabel: "西班牙文",
        spanishDesc: "ElevenLabs",
        frenchLabel: "法文",
        frenchDesc: "ElevenLabs",
        germanLabel: "德文",
        germanDesc: "ElevenLabs",
        moreLabel: "更多",
        moreDesc: "即将推出",
        
        // Pricing
        pricingTitle: "💰 简单定价",
        freeTitle: "免费版",
        freePrice: "$0",
        freeFeature1: "3个项目",
        freeFeature2: "5分钟视频",
        freeFeature3: "基础角色库",
        freeFeature4: "英文TTS",
        freeButton: "开始使用",
        proTitle: "专业版",
        proPrice: "$29",
        proMonth: "/月",
        proPopular: "最受欢迎",
        proFeature1: "无限项目",
        proFeature2: "30分钟视频",
        proFeature3: "高级角色库",
        proFeature4: "多语言TTS",
        proFeature5: "角色一致性AI",
        proButton: "开始专业版试用",
        enterpriseTitle: "企业版",
        enterprisePrice: "$99",
        enterpriseFeature1: "团队协作",
        enterpriseFeature2: "API访问",
        enterpriseFeature3: "自定义角色训练",
        enterpriseFeature4: "优先支持",
        enterpriseFeature5: "白标选项",
        enterpriseButton: "联系销售",
        
        // CTA
        ctaTitle: "准备创建精彩的漫剧视频了吗？",
        ctaSubtitle: "加入已经在使用AI漫剧制作器的数千名创作者",
        startNow: "🚀 立即开始创作",
        contactUs: "📧 联系我们",
        
        // Footer
        footerText: "用 ❤️ 为全球创作者打造",
        support: "支持",
        privacy: "隐私",
        terms: "条款"
    },
    ja: {
        navTitle: "AI ウェブトゥーンメーカー",
        navSubtitle: "ストーリーファースト",
        signIn: "サインイン",
        heroTitle: "🎬 ストーリーファースト",
        heroSubtitle: "完璧なキャラクター一貫性でウェブトゥーン動画を作成",
        heroDescription: "ストーリー + キャラクター + 多言語リップシンクを組み合わせた唯一のAIツール",
        startCreating: "🚀 無料で作成開始",
        watchDemo: "🎭 デモを見る",
        feature1Title: "ストーリーファースト",
        feature1Desc: "キャラクター開発と感情の進行を含む完全なストーリーアークを生成。単なる動画ではなく、意味のある物語。",
        feature2Title: "キャラクター一貫性",
        feature2Desc: "シーン間でキャラクターの外観を一貫して維持。一つのキャラクター、複数のシーン、毎回完璧な一貫性。",
        feature3Title: "完璧なリップシンク",
        feature3Desc: "多言語リップシンクサポート。英語、中国語、日本語、韓国語、スペイン語、フランス語、ドイツ語 - すべて完璧な口の動き。",
        whyDifferentTitle: "私たちの違い",
        otherToolsTitle: "❌ 他のAI動画ツール",
        ourToolTitle: "✅ AI ウェブトゥーンメーカー",
        runway: "Runway: 動画品質は良いが、ストーリーの一貫性がない",
        civitai: "Civitai: 静止画のみ、動画なし",
        did: "D-ID: 実写のみ、アニメスタイルなし",
        heyGen: "HeyGen: ビジネス向け、創造性なし",
        synthesia: "Synthesia: テンプレートのみ、カスタマイズ不可",
        storyCoherence: "ストーリーの一貫性: 完全な物語アーク",
        characterConsistency: "キャラクターの一貫性: 同一キャラクター、全シーン",
        multiLangLipSync: "多言語リップシンク: 7言語以上対応",
        creatorFocused: "クリエイター重視: ストーリーテラー向け",
        animeStyle: "アニメ/マンガスタイル: ウェブトゥーンに最適",
        languageSupportTitle: "🌍 グローバル言語サポート",
        englishLabel: "英語",
        englishDesc: "ElevenLabs プレミアム",
        chineseLabel: "中国語",
        chineseDesc: "Azure 最適化",
        japaneseLabel: "日本語",
        japaneseDesc: "アニメスタイル",
        koreanLabel: "韓国語",
        koreanDesc: "K-pop スタイル",
        spanishLabel: "スペイン語",
        spanishDesc: "ElevenLabs",
        frenchLabel: "フランス語",
        frenchDesc: "ElevenLabs",
        germanLabel: "ドイツ語",
        germanDesc: "ElevenLabs",
        moreLabel: "その他",
        moreDesc: "近日公開",
        pricingTitle: "💰 シンプルな価格設定",
        freeTitle: "無料",
        freePrice: "$0",
        freeFeature1: "3 プロジェクト",
        freeFeature2: "5分間の動画",
        freeFeature3: "基本キャラクター",
        freeFeature4: "英語 TTS",
        freeButton: "始める",
        proTitle: "プロ",
        proPrice: "$29",
        proMonth: "/月",
        proPopular: "人気",
        proFeature1: "無制限プロジェクト",
        proFeature2: "30分間の動画",
        proFeature3: "高度なキャラクター",
        proFeature4: "多言語 TTS",
        proFeature5: "キャラクター一貫性 AI",
        proButton: "プロ版を試す",
        enterpriseTitle: "エンタープライズ",
        enterprisePrice: "$99",
        enterpriseFeature1: "チームコラボレーション",
        enterpriseFeature2: "API アクセス",
        enterpriseFeature3: "カスタムキャラクタートレーニング",
        enterpriseFeature4: "優先サポート",
        enterpriseFeature5: "ホワイトラベルオプション",
        enterpriseButton: "営業に連絡",
        ctaTitle: "素晴らしいウェブトゥーン動画を作成する準備はできましたか？",
        ctaSubtitle: "すでにAI ウェブトゥーンメーカーを使用している数千人のクリエイターに参加しましょう",
        startNow: "🚀 今すぐ作成開始",
        contactUs: "📧 お問い合わせ",
        footerText: "世界中のクリエイターのために ❤️ で作成",
        support: "サポート",
        privacy: "プライバシー",
        terms: "利用規約"
    },
    ko: {
        navTitle: "AI 웹툰 메이커",
        navSubtitle: "스토리텔링 우선",
        signIn: "로그인",
        heroTitle: "🎬 스토리텔링 우선",
        heroSubtitle: "완벽한 캐릭터 일관성으로 웹툰 비디오 제작",
        heroDescription: "스토리 + 캐릭터 + 다국어 립싱크를 결합한 유일한 AI 도구",
        startCreating: "🚀 무료로 제작 시작",
        watchDemo: "🎭 데모 보기",
        feature1Title: "스토리텔링 우선",
        feature1Desc: "캐릭터 개발과 감정적 진행을 포함한 완전한 스토리 아크 생성. 단순한 비디오가 아닌 의미 있는 내러티브.",
        feature2Title: "캐릭터 일관성",
        feature2Desc: "장면 간 캐릭터 외모의 일관성 유지. 하나의 캐릭터, 여러 장면, 매번 완벽한 일관성.",
        feature3Title: "완벽한 립싱크",
        feature3Desc: "다국어 립싱크 지원. 영어, 중국어, 일본어, 한국어, 스페인어, 프랑스어, 독일어 - 모두 완벽한 입 움직임.",
        whyDifferentTitle: "우리의 차별점",
        otherToolsTitle: "❌ 다른 AI 비디오 도구",
        ourToolTitle: "✅ AI 웹툰 메이커",
        runway: "Runway: 비디오 품질은 좋지만 스토리 일관성 없음",
        civitai: "Civitai: 정지 이미지만, 비디오 없음",
        did: "D-ID: 실제 사람만, 애니메이션 스타일 없음",
        heyGen: "HeyGen: 비즈니스 중심, 창의성 없음",
        synthesia: "Synthesia: 템플릿만, 사용자 정의 불가",
        storyCoherence: "스토리 일관성: 완전한 내러티브 아크",
        characterConsistency: "캐릭터 일관성: 동일한 캐릭터, 모든 장면",
        multiLangLipSync: "다국어 립싱크: 7개 이상의 언어 지원",
        creatorFocused: "크리에이터 중심: 스토리텔러를 위해 제작",
        animeStyle: "애니메이션/만화 스타일: 웹툰에 완벽",
        languageSupportTitle: "🌍 글로벌 언어 지원",
        englishLabel: "영어",
        englishDesc: "ElevenLabs 프리미엄",
        chineseLabel: "중국어",
        chineseDesc: "Azure 최적화",
        japaneseLabel: "일본어",
        japaneseDesc: "애니메이션 스타일",
        koreanLabel: "한국어",
        koreanDesc: "K-pop 스타일",
        spanishLabel: "스페인어",
        spanishDesc: "ElevenLabs",
        frenchLabel: "프랑스어",
        frenchDesc: "ElevenLabs",
        germanLabel: "독일어",
        germanDesc: "ElevenLabs",
        moreLabel: "더 보기",
        moreDesc: "곧 출시 예정",
        pricingTitle: "💰 간단한 가격",
        freeTitle: "무료",
        freePrice: "$0",
        freeFeature1: "3개 프로젝트",
        freeFeature2: "5분 비디오",
        freeFeature3: "기본 캐릭터",
        freeFeature4: "영어 TTS",
        freeButton: "시작하기",
        proTitle: "프로",
        proPrice: "$29",
        proMonth: "/월",
        proPopular: "인기",
        proFeature1: "무제한 프로젝트",
        proFeature2: "30분 비디오",
        proFeature3: "고급 캐릭터",
        proFeature4: "다국어 TTS",
        proFeature5: "캐릭터 일관성 AI",
        proButton: "프로 버전 체험",
        enterpriseTitle: "엔터프라이즈",
        enterprisePrice: "$99",
        enterpriseFeature1: "팀 협업",
        enterpriseFeature2: "API 액세스",
        enterpriseFeature3: "맞춤형 캐릭터 훈련",
        enterpriseFeature4: "우선 지원",
        enterpriseFeature5: "화이트 라벨 옵션",
        enterpriseButton: "영업팀 문의",
        ctaTitle: "놀라운 웹툰 비디오를 만들 준비가 되셨나요?",
        ctaSubtitle: "이미 AI 웹툰 메이커를 사용하고 있는 수천 명의 크리에이터와 함께하세요",
        startNow: "🚀 지금 제작 시작",
        contactUs: "📧 문의하기",
        footerText: "전 세계 크리에이터를 위해 ❤️로 제작",
        support: "지원",
        privacy: "개인정보 처리방침",
        terms: "이용 약관"
    },
    es: {
        navTitle: "Creador de Webtoon IA",
        navSubtitle: "Narrativa Primero",
        signIn: "Iniciar Sesión",
        heroTitle: "🎬 Narrativa Primero",
        heroSubtitle: "Crea Videos de Webtoon con Consistencia Perfecta de Personajes",
        heroDescription: "La única herramienta de IA que combina Historia + Personaje + Sincronización Labial Multiidioma",
        startCreating: "🚀 Comenzar Gratis",
        watchDemo: "🎭 Ver Demo",
        feature1Title: "Narrativa Primero",
        feature1Desc: "Genera arcos narrativos completos con desarrollo de personajes y progresión emocional. No solo videos, sino narrativas significativas.",
        feature2Title: "Consistencia de Personajes",
        feature2Desc: "Mantén la apariencia consistente del personaje en todas las escenas. Un personaje, múltiples escenas, consistencia perfecta siempre.",
        feature3Title: "Sincronización Labial Perfecta",
        feature3Desc: "Soporte de sincronización labial multiidioma. Inglés, chino, japonés, coreano, español, francés, alemán - todo con animación bucal perfecta.",
        whyDifferentTitle: "Por Qué Somos Diferentes",
        otherToolsTitle: "❌ Otras Herramientas de Video IA",
        ourToolTitle: "✅ Creador de Webtoon IA",
        runway: "Runway: Excelentes videos, sin coherencia narrativa",
        civitai: "Civitai: Solo imágenes estáticas, sin video",
        did: "D-ID: Solo humanos reales, sin estilo anime",
        heyGen: "HeyGen: Enfoque empresarial, sin creatividad",
        synthesia: "Synthesia: Solo plantillas, sin personalización",
        storyCoherence: "Coherencia Narrativa: Arcos narrativos completos",
        characterConsistency: "Consistencia de Personajes: Mismo personaje, cada escena",
        multiLangLipSync: "Sincronización Labial: Soporte para más de 7 idiomas",
        creatorFocused: "Enfoque en Creadores: Construido para narradores",
        animeStyle: "Estilo Anime/Manga: Perfecto para webtoons",
        languageSupportTitle: "🌍 Soporte de Idiomas Global",
        englishLabel: "Inglés",
        englishDesc: "ElevenLabs Premium",
        chineseLabel: "Chino",
        chineseDesc: "Azure Optimizado",
        japaneseLabel: "Japonés",
        japaneseDesc: "Estilo Anime",
        koreanLabel: "Coreano",
        koreanDesc: "Estilo K-pop",
        spanishLabel: "Español",
        spanishDesc: "ElevenLabs",
        frenchLabel: "Francés",
        frenchDesc: "ElevenLabs",
        germanLabel: "Alemán",
        germanDesc: "ElevenLabs",
        moreLabel: "Más",
        moreDesc: "Próximamente",
        pricingTitle: "💰 Precios Simples",
        freeTitle: "Gratis",
        freePrice: "$0",
        freeFeature1: "3 proyectos",
        freeFeature2: "Videos de 5 minutos",
        freeFeature3: "Personajes básicos",
        freeFeature4: "TTS en inglés",
        freeButton: "Comenzar",
        proTitle: "Pro",
        proPrice: "$29",
        proMonth: "/mes",
        proPopular: "POPULAR",
        proFeature1: "Proyectos ilimitados",
        proFeature2: "Videos de 30 minutos",
        proFeature3: "Personajes avanzados",
        proFeature4: "TTS multiidioma",
        proFeature5: "IA de consistencia de personajes",
        proButton: "Prueba Pro",
        enterpriseTitle: "Empresa",
        enterprisePrice: "$99",
        enterpriseFeature1: "Colaboración en equipo",
        enterpriseFeature2: "Acceso a API",
        enterpriseFeature3: "Entrenamiento de personajes personalizado",
        enterpriseFeature4: "Soporte prioritario",
        enterpriseFeature5: "Opciones de marca blanca",
        enterpriseButton: "Contactar Ventas",
        ctaTitle: "¿Listo para Crear Videos de Webtoon Increíbles?",
        ctaSubtitle: "Únete a miles de creadores que ya están usando el Creador de Webtoon IA",
        startNow: "🚀 Comenzar Ahora",
        contactUs: "📧 Contáctanos",
        footerText: "Hecho con ❤️ para creadores globales",
        support: "Soporte",
        privacy: "Privacidad",
        terms: "Términos"
    },
    fr: {
        navTitle: "Créateur Webtoon IA",
        navSubtitle: "Narration d'Abord",
        signIn: "Se Connecter",
        heroTitle: "🎬 Narration d'Abord",
        heroSubtitle: "Créez des Vidéos Webtoon avec une Cohérence Parfaite des Personnages",
        heroDescription: "Le seul outil IA qui combine Histoire + Personnage + Synchronisation Labiale Multilingue",
        startCreating: "🚀 Commencer Gratuitement",
        watchDemo: "🎭 Voir la Démo",
        feature1Title: "Narration d'Abord",
        feature1Desc: "Générez des arcs narratifs complets avec développement des personnages et progression émotionnelle. Pas seulement des vidéos, mais des récits significatifs.",
        feature2Title: "Cohérence des Personnages",
        feature2Desc: "Maintenez l'apparence cohérente des personnages à travers les scènes. Un personnage, plusieurs scènes, cohérence parfaite à chaque fois.",
        feature3Title: "Synchronisation Labiale Parfaite",
        feature3Desc: "Support de synchronisation labiale multilingue. Anglais, chinois, japonais, coréen, espagnol, français, allemand - tous avec animation buccale parfaite.",
        whyDifferentTitle: "Pourquoi Nous Sommes Différents",
        otherToolsTitle: "❌ Autres Outils Vidéo IA",
        ourToolTitle: "✅ Créateur Webtoon IA",
        runway: "Runway : Belles vidéos, aucune cohérence narrative",
        civitai: "Civitai : Images statiques seulement, pas de vidéo",
        did: "D-ID : Humains réels seulement, pas de style anime",
        heyGen: "HeyGen : Axé business, pas de créativité",
        synthesia: "Synthesia : Modèles uniquement, pas de personnalisation",
        storyCoherence: "Cohérence Narrative : Arcs narratifs complets",
        characterConsistency: "Cohérence des Personnages : Même personnage, chaque scène",
        multiLangLipSync: "Synchronisation Labiale : Supporte 7+ langues",
        creatorFocused: "Axé Créateur : Conçu pour les conteurs",
        animeStyle: "Style Anime/Manga : Parfait pour les webtoons",
        languageSupportTitle: "🌍 Support Linguistique Global",
        englishLabel: "Anglais",
        englishDesc: "ElevenLabs Premium",
        chineseLabel: "Chinois",
        chineseDesc: "Azure Optimisé",
        japaneseLabel: "Japonais",
        japaneseDesc: "Style Anime",
        koreanLabel: "Coréen",
        koreanDesc: "Style K-pop",
        spanishLabel: "Espagnol",
        spanishDesc: "ElevenLabs",
        frenchLabel: "Français",
        frenchDesc: "ElevenLabs",
        germanLabel: "Allemand",
        germanDesc: "ElevenLabs",
        moreLabel: "Plus",
        moreDesc: "Bientôt",
        pricingTitle: "💰 Prix Simples",
        freeTitle: "Gratuit",
        freePrice: "$0",
        freeFeature1: "3 projets",
        freeFeature2: "Vidéos de 5 minutes",
        freeFeature3: "Personnages de base",
        freeFeature4: "TTS anglais",
        freeButton: "Commencer",
        proTitle: "Pro",
        proPrice: "$29",
        proMonth: "/mois",
        proPopular: "POPULAIRE",
        proFeature1: "Projets illimités",
        proFeature2: "Vidéos de 30 minutes",
        proFeature3: "Personnages avancés",
        proFeature4: "TTS multilingue",
        proFeature5: "IA de cohérence des personnages",
        proButton: "Essai Pro",
        enterpriseTitle: "Entreprise",
        enterprisePrice: "$99",
        enterpriseFeature1: "Collaboration d'équipe",
        enterpriseFeature2: "Accès API",
        enterpriseFeature3: "Entraînement de personnages personnalisé",
        enterpriseFeature4: "Support prioritaire",
        enterpriseFeature5: "Options marque blanche",
        enterpriseButton: "Contacter Ventes",
        ctaTitle: "Prêt à Créer des Vidéos Webtoon Incroyables ?",
        ctaSubtitle: "Rejoignez des milliers de créateurs qui utilisent déjà le Créateur Webtoon IA",
        startNow: "🚀 Commencer Maintenant",
        contactUs: "📧 Nous Contacter",
        footerText: "Fait avec ❤️ pour les créateurs mondiaux",
        support: "Support",
        privacy: "Confidentialité",
        terms: "Conditions"
    },
    de: {
        navTitle: "KI-Webtoon-Ersteller",
        navSubtitle: "Storytelling Zuerst",
        signIn: "Anmelden",
        heroTitle: "🎬 Storytelling Zuerst",
        heroSubtitle: "Erstelle Webtoon-Videos mit Perfekter Charakterkonsistenz",
        heroDescription: "Das einzige KI-Tool, das Geschichte + Charakter + Mehrsprachige Lippensynchronisation kombiniert",
        startCreating: "🚀 Kostenlos Beginnen",
        watchDemo: "🎭 Demo Ansehen",
        feature1Title: "Storytelling Zuerst",
        feature1Desc: "Generiere vollständige Handlungsbögen mit Charakterentwicklung und emotionaler Progression. Nicht nur Videos, sondern bedeutungsvolle Erzählungen.",
        feature2Title: "Charakterkonsistenz",
        feature2Desc: "Behalte konsistentes Charakteraussehen über Szenen hinweg. Ein Charakter, mehrere Szenen, jedes Mal perfekte Konsistenz.",
        feature3Title: "Perfekte Lippensynchronisation",
        feature3Desc: "Mehrsprachige Lippensynchronisationsunterstützung. Englisch, Chinesisch, Japanisch, Koreanisch, Spanisch, Französisch, Deutsch - alle mit perfekter Mundanimation.",
        whyDifferentTitle: "Warum Wir Anders Sind",
        otherToolsTitle: "❌ Andere KI-Video-Tools",
        ourToolTitle: "✅ KI-Webtoon-Ersteller",
        runway: "Runway: Tolle Videos, keine Story-Kohärenz",
        civitai: "Civitai: Nur statische Bilder, kein Video",
        did: "D-ID: Nur echte Menschen, kein Anime-Stil",
        heyGen: "HeyGen: Geschäftsorientiert, keine Kreativität",
        synthesia: "Synthesia: Nur Vorlagen, keine Anpassung",
        storyCoherence: "Story-Kohärenz: Vollständige Erzählbögen",
        characterConsistency: "Charakterkonsistenz: Derselbe Charakter, jede Szene",
        multiLangLipSync: "Lippensynchronisation: Unterstützt 7+ Sprachen",
        creatorFocused: "Ersteller-Fokus: Für Geschichtenerzähler gebaut",
        animeStyle: "Anime/Manga-Stil: Perfekt für Webtoons",
        languageSupportTitle: "🌍 Globale Sprachunterstützung",
        englishLabel: "Englisch",
        englishDesc: "ElevenLabs Premium",
        chineseLabel: "Chinesisch",
        chineseDesc: "Azure Optimiert",
        japaneseLabel: "Japanisch",
        japaneseDesc: "Anime-Stil",
        koreanLabel: "Koreanisch",
        koreanDesc: "K-pop Stil",
        spanishLabel: "Spanisch",
        spanishDesc: "ElevenLabs",
        frenchLabel: "Französisch",
        frenchDesc: "ElevenLabs",
        germanLabel: "Deutsch",
        germanDesc: "ElevenLabs",
        moreLabel: "Mehr",
        moreDesc: "Demnächst",
        pricingTitle: "💰 Einfache Preise",
        freeTitle: "Kostenlos",
        freePrice: "$0",
        freeFeature1: "3 Projekte",
        freeFeature2: "5-Minuten-Videos",
        freeFeature3: "Basis-Charaktere",
        freeFeature4: "Englisch TTS",
        freeButton: "Starten",
        proTitle: "Pro",
        proPrice: "$29",
        proMonth: "/Monat",
        proPopular: "BELIEBT",
        proFeature1: "Unbegrenzte Projekte",
        proFeature2: "30-Minuten-Videos",
        proFeature3: "Fortgeschrittene Charaktere",
        proFeature4: "Mehrsprachiges TTS",
        proFeature5: "Charakterkonsistenz-KI",
        proButton: "Pro testen",
        enterpriseTitle: "Enterprise",
        enterprisePrice: "$99",
        enterpriseFeature1: "Team-Kollaboration",
        enterpriseFeature2: "API-Zugriff",
        enterpriseFeature3: "Benutzerdefiniertes Charaktertraining",
        enterpriseFeature4: "Prioritäts-Support",
        enterpriseFeature5: "White-Label-Optionen",
        enterpriseButton: "Vertrieb kontaktieren",
        ctaTitle: "Bereit, Erstaunliche Webtoon-Videos zu Erstellen?",
        ctaSubtitle: "Schließe dich Tausenden von Erstellern an, die bereits den KI-Webtoon-Ersteller verwenden",
        startNow: "🚀 Jetzt Beginnen",
        contactUs: "📧 Kontaktiere Uns",
        footerText: "Mit ❤️ für globale Ersteller gemacht",
        support: "Support",
        privacy: "Datenschutz",
        terms: "AGB"
    }
};

export type Language = 'en' | 'zh' | 'ja' | 'ko' | 'es' | 'fr' | 'de';
